export default __webpack_public_path__ + "static/media/03.c5b51f55.jpg";